"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageComponent;
const react_1 = __importStar(require("react"));
function LazyLoadImage({ src, alt, className, ...props }) {
    const [imgSrc, setImageSrc] = (0, react_1.useState)('');
    const onLoad = (0, react_1.useCallback)(() => {
        setImageSrc(src);
    }, [src]);
    const onError = (0, react_1.useCallback)(() => {
        console.error(`failed to load image ${src}`);
    }, [src]);
    (0, react_1.useEffect)(() => {
        const img = new Image();
        img.src = src;
        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);
        return () => {
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
        };
    }, [src, onLoad, onError]);
    return react_1.default.createElement("img", { src: imgSrc, alt: alt, className: className, ...props });
}
function ImageComponent({ src, alt, lazy = false, className, ...props }) {
    if (lazy) {
        return (react_1.default.createElement(LazyLoadImage, { src: src, alt: alt, className: className, ...props }));
    }
    return react_1.default.createElement("img", { src: src, alt: alt, className: className, ...props });
}
